// extracted by mini-css-extract-plugin
export default {"container":"VZ-z"};